module.exports = __webpack_public_path__ + "media/icons/opony-letnie-green-8ac445b4.png";